var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Vue, PropSync } from 'vue-property-decorator';
import Accordion from '@/components/Accordion.vue';
import { connect } from '@/overmind';
let ExportationsTypes = class ExportationsTypes extends Vue {
    constructor() {
        super(...arguments);
        this.open = true;
        this.exportOptions = [
            {
                label: 'Uma empresa por linha',
                value: 'companies',
            },
            {
                label: 'Um decisor por linha',
                value: 'decisors',
            },
            {
                label: 'Um e-mail por linha',
                value: 'email',
            },
        ];
    }
    mounted() {
        // @ts-ignore
        const user = this.$auth.user();
        if (user &&
            user.features &&
            user.features.includes('enrichment_whatsapp') &&
            this.exportStats.whatsapps > 0) {
            this.exportOptions.push({
                label: 'Um whatsapp por linha',
                value: 'whatsapp',
            });
        }
    }
};
__decorate([
    PropSync('currentType', { default: 'companies' })
], ExportationsTypes.prototype, "exportType", void 0);
ExportationsTypes = __decorate([
    Component(connect(({ state: { infosets: { exportStats }, }, }) => ({
        exportStats,
    }), {
        name: 'ExportationsTypes',
        components: {
            Accordion,
        },
    }))
], ExportationsTypes);
export default ExportationsTypes;
